"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PINInput = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var PINInput = /** @class */ (function (_super) {
    __extends(PINInput, _super);
    function PINInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isEmpty = function (value) {
            if (Array.isArray(value)) {
                return value.length < 1;
            }
            else if (typeof value === "string") {
                return !value;
            }
            return value == null;
        };
        _this.getError = function (value) {
            var _a;
            var error = null;
            var transFunc = (_a = _this.props.t) !== null && _a !== void 0 ? _a : (function (v) { return v; });
            if (_this.props.validation) {
                var validation = _this.props.validation(value, transFunc);
                if (typeof validation === "string") {
                    error = validation;
                }
                else if (!validation) {
                    error = transFunc("general.error.message");
                }
                else {
                    error = null;
                }
            }
            if (_this.isEmpty(value)) {
                error = _this.props.required ? transFunc("validator.error.required") : null;
            }
            return error;
        };
        _this.getValueOnChange = function (_, __) {
            throw Error("PINInput: getValueOnChange(event?) must be implemented by sub classes");
        };
        _this.onChange = function (event, complement) {
            var value = _this.getValueOnChange(event, complement);
            if (value === undefined) {
                return;
            }
            var error = _this.getError(value);
            _this.setState({ error: error });
            if (_this.props.onChange) {
                _this.props.onChange(_this.props.name, value);
            }
            if (_this.props.onChangeForm) {
                _this.props.onChangeForm(_this.props.name, value, _this.props.defaultValue, error);
            }
            if (event && event.stopPropagation) {
                event.stopPropagation();
            }
        };
        return _this;
    }
    PINInput.prototype.componentDidMount = function () {
        if (!this.props.onChangeForm) {
            return;
        }
        /* Inform the form of the input initial value and validity */
        var value = this.props.value || this.props.defaultValue || null;
        var error = this.getError(value);
        this.setState({ error: this.props.showInitialError ? error : null });
        this.props.onChangeForm(this.props.name, value, this.props.defaultValue, error);
    };
    PINInput.prototype.render = function () {
        return null;
    };
    PINInput.propTypes = {
        name: prop_types_1.default.string,
        value: prop_types_1.default.any,
        defaultValue: prop_types_1.default.any,
        label: prop_types_1.default.string,
        error: prop_types_1.default.string,
        onChange: prop_types_1.default.func,
        onChangeForm: prop_types_1.default.func,
        validation: prop_types_1.default.func,
        t: prop_types_1.default.func,
        required: prop_types_1.default.bool,
        hiddenRequired: prop_types_1.default.bool,
        showInitialError: prop_types_1.default.bool,
    };
    PINInput.defaultProps = {
        t: function (v) { return v; }
    };
    return PINInput;
}(react_1.default.Component));
exports.PINInput = PINInput;
//# sourceMappingURL=PINInput.js.map